const ja = {
  error_title: 'エラーが発生しました',
  error_message:
    'エラーが発生しました。お手数ですが、ページを再読み込みするか、しばらくしてからもう一度お試しください。',
  error_reload_button: '画面をリロードする',
  error_reload_hint: '問題が続く場合は、サポートにお問い合わせください。',

  not_found_title: 'ページが見つかりません',
  not_found_message: 'お探しのページは存在しないか、移動した可能性があります。',
  not_found_back_button: 'ホームに戻る',

  validation_bad_request: '入力内容に誤りがあります。もう一度ご確認ください。',

  // Navigation
  nav_home: 'ホーム',
  nav_dashboard: '運用状況サマリ',
  nav_group_dashboard: 'ダッシュボード',
  nav_group_applicant_import: '応募者の取り込み',
  nav_group_mail_sms: 'メール・SMS',
  nav_use_media: '求人媒体の管理',

  // Home page — information section
  home_loading: 'Loading…',
  home_information_title: 'Information',

  // Home page — startup section
  home_startup_title: 'Start Up',
  home_startup_all_chapter_title: 'ALL Chapter',
  home_startup_all_chapter_description: 'イチからSAISOKUをセッティングしよう',
  home_startup_chap1_title: 'Chapter １',
  home_startup_chap1_description: '求人媒体を登録しよう',
  home_startup_chap2_title: 'Chapter ２',
  home_startup_chap2_description: '面談までの条件を設定しよう',
  home_startup_chap3_title: 'Chapter ３',
  home_startup_chap3_description: '応募者ごとの対応を設定しよう',
  home_startup_coming_soon: 'coming soon',

  // Use-media Create / Update
  use_media_create_title: '求人媒体の新規登録',
  use_media_update_title: '求人媒体の編集',
  use_media_account_alias_label: '設定名',
  use_media_account_alias_placeholder: '設定名を入力',
  use_media_account_alias_error: '設定名は64文字以内で入力してください。',
  use_media_duplicate_account_alias:
    '同じ媒体・設定名の組み合わせはすでに登録されています。別の設定名を入力してください。',
  use_media_media_label: '媒体',
  use_media_media_free_word_label: 'フリーワードから探す',
  use_media_media_list_label: '一覧から探す',
  use_media_media_placeholder: '媒体名をフリーワードで探す',
  use_media_media_error: '媒体を選択してください。',
  use_media_media_type_error:
    '媒体の種類情報が読み込まれていません。しばらく待ってから再度お試しください。',
  use_media_login_confirm_button: 'ログイン確認',
  use_media_login_confirm_error: 'ログイン確認を行ってください。',
  use_media_login_confirm_success: 'ログイン確認に成功しました。',
  use_media_login_confirm_failure: 'ログインに失敗しました。入力内容を確認してください。',
  use_media_login_confirm_note1:
    '※ 複数回のログイン失敗でアカウントがロックされる可能性があります。',
  use_media_login_confirm_note2: '※ 安全のため、失敗後は一度正規のログイン画面をご利用ください。',
  use_media_job_number_label: 'お仕事No.の取得方法',
  use_media_job_number_description_line_start: 'お仕事No.の取得方法の詳細は',
  use_media_job_number_help_link: 'ヘルプページ',
  use_media_job_number_description_line_end: 'をご参照ください。',
  use_media_job_number_csv_label: '求人媒体のCSV/画面の項目から取得',
  use_media_job_number_csv_branch_number_label: '求人媒体のCSV/画面の項目から取得（枝番利用）',
  use_media_job_number_csv_column_label: '項目',
  use_media_job_number_csv_column_error: '項目を選択してください。',
  use_media_job_number_extract_label: '形式',
  use_media_job_number_extract_error: '形式を選択してください。',
  use_media_job_number_extract_branch_number_label: '枝番の形式',
  use_media_job_number_extract_branch_number_error: '枝番の形式を選択してください。',
  use_media_job_number_extract_branch_number_duplicate_error:
    '形式と枝番の形式は異なる値を選択してください。',
  use_media_job_number_extract_branch_number_forbidden_combination_error:
    'この形式の組み合わせは選択できません。別の形式を選択してください。',
  use_media_job_number_media_extract_label: '媒体から抽出した値を使う',
  use_media_job_number_media_extract_note: '※ 設定方法についてはPortersまでお問い合わせください。',
  use_media_job_number_fixed_label: '固定のお仕事No.を使う',
  use_media_job_number_fixed_input_placeholder: 'お仕事No.を入力してください。',
  use_media_job_number_fixed_error: 'お仕事No.を入力してください。',
  use_media_job_number_fixed_format_error: 'お仕事No.は半角数字で入力してください。',
  use_media_job_number_required_error: 'お仕事No.の取得方法を選択してください。',
  use_media_register_channel_label: 'この媒体からの応募をPORTERSで集計する',
  use_media_register_channel_use_label: '集計する',
  use_media_register_channel_not_use_label: '集計しない',
  use_media_register_channel_select_label: 'PORTERSに反映される選択肢を選んでください。',
  use_media_register_channel_required_error: 'どちらかを選択してください。',
  use_media_register_channel_alias_error: '選択肢を選んでください。',
  use_media_submit_button: '登録する',
  use_media_update_button: '更新する',
  use_media_copy_suffix: 'のコピー',
  use_media_back_to_list_button: '一覧に戻る',
  use_media_change_password_button: '変更する',
  use_media_show_password: 'パスワードを表示',
  use_media_hide_password: 'パスワードを非表示',
  use_media_create_success: '登録が完了しました。',
  use_media_update_success: '更新が完了しました。',
  use_media_login_field_required: '{label}を入力してください。',

  // Complete screen
  use_media_complete_create_title: '求人媒体「{accountAlias}」の作成が終了しました',
  use_media_complete_update_title: '求人媒体「{accountAlias}」の変更が終了しました',
  use_media_complete_status_note:
    '作成後、設定は「停止中」のステータスとなります。連携開始したい場合は一覧画面からステータスを変更してください。',
  use_media_complete_mail_note:
    'この設定の応募通知先メールアドレスは以下となります。\n連携開始前にこのアドレスを媒体の応募通知先に設定ください。\n媒体一覧からもアドレスをコピーすることができます。',
  use_media_complete_clipboard_alert: '応募通知先メールアドレスをクリップボードにコピーしました。',
  use_media_complete_clipboard_error:
    '応募通知先メールアドレスのコピーに失敗しました。手動でコピーしてください。',
  use_media_complete_back_button: '求人媒体一覧に戻る',
  use_media_complete_add_more_button: '続けて登録する',

  // Extract rules
  extract_rule_1: 'そのまま使う',
  extract_rule_2: '/（半角スラッシュ）後の数字を取得',
  extract_rule_3: '-（半角ハイフン）前の数字を取得',
  extract_rule_5: '-（半角ハイフン）後の数字を取得',
  extract_rule_4: '／（全角スラッシュ）後の数字を取得',
  extract_rule_6: '末尾１桁',
  extract_rule_7: '末尾２桁',
  extract_rule_8: '末尾３桁',

  // Use-media List
  use_media_list_title: '求人媒体の管理',
  use_media_list_search_placeholder: '設定名・媒体名を入力してください。',
  use_media_list_filter_active_only: '連携中のみ表示',
  use_media_list_create_button: '新規登録',
  use_media_list_col_account_alias: '設定名',
  use_media_list_col_media: '媒体',
  use_media_list_col_status: 'ステータス',
  use_media_list_col_media_type: '取り込み仕様',
  use_media_list_col_mail_address: '応募通知先メールアドレス',
  use_media_list_col_edit: '編集',
  use_media_list_col_copy: '複製',
  use_media_list_col_delete: '削除',
  use_media_list_status_inactive: '停止中',
  use_media_list_status_active: '連携中',
  use_media_list_status_test_mode: 'テストモード',
  use_media_type_beautiful_soupe: 'リアルタイム',
  use_media_type_email: 'メール',
  use_media_type_beautiful_soupe_periodic: '定期実行',
  use_media_type_unknown: '不明',
  use_media_list_pagination_info: '{start}-{end} / {total}件',
  use_media_list_no_data: '登録された媒体はありません。',

  // Use-media List — Status change dialogs
  use_media_status_to_inactive_title: '連携を停止します',
  use_media_status_to_inactive_button: '停止する',
  use_media_status_to_active_title: '連携を開始します',
  use_media_status_to_active_checklist_heading: 'データの取り込みに関して',
  use_media_status_to_active_button: '連携開始する',
  use_media_status_to_test_mode_title: 'テストモードに変更します',
  use_media_status_to_test_mode_button: '変更する',
  use_media_status_test_mode_after_message:
    'テスト用メールアドレスを使用して求人媒体への応募をお願いいたします。応募後、Portersに登録されない、通知が来ない、などがございましたら一度応募者のメールアドレスのご確認をお願いいたします。',
  use_media_status_cancel_button: 'キャンセルして閉じる',
  use_media_status_close_button: '閉じる',
  use_media_status_success_inactive: '「{accountAlias}」の連携が停止しました。',
  use_media_status_success_active: '「{accountAlias}」が連携中になりました。',
  use_media_status_success_test_mode: 'テストモードとなりました。',
  use_media_status_dropdown_start: '連携開始',
  use_media_status_dropdown_stop: '停止する',
  use_media_status_dropdown_test_mode: 'テストモード',
  use_media_status_test_domain_empty: 'テスト応募用ドメインは設定されていません。',
  use_media_status_test_address_empty: 'テスト応募用メールアドレスは設定されていません。',

  // Use-media List — Delete dialogs
  use_media_delete_confirm_title: '「{accountAlias}」を削除しますか？',
  use_media_delete_confirm_button: '削除する',
  use_media_delete_cancel_button: 'キャンセル',
  use_media_delete_success: '「{accountAlias}」を削除しました。',
  use_media_delete_cannot_title: '削除できません',
  use_media_delete_cannot_message: '削除するには、ステータスを「停止中」に変更してください。',
  use_media_delete_cannot_close_button: '閉じる',
  dialog_cancel_button: 'キャンセル',
  dialog_close_button: '閉じる',
  use_media_list_items_per_page: '件/ページ',

  // Dashboard — Report
  dashboard_report_title: '運用状況サマリ',
  dashboard_report_description: '期間を指定して運用状況のサマリをExcelファイルで出力できます',
  dashboard_report_downloading: 'ダウンロード中...',
  dashboard_report_download_button: 'Excelダウンロード',
  dashboard_report_date_range_placeholder: '期間を選択してください',
  dashboard_report_no_data: '対象期間のデータがありません。',
  dashboard_report_download_complete: 'ダウンロードが完了しました。',
  dashboard_report_download_error: 'ダウンロードに失敗しました。再度お試しください。',
  dashboard_report_query_timeout_title: 'レポート生成がタイムアウトしました',
  dashboard_report_query_timeout_message:
    'レポートの生成に時間がかかりすぎました。検索条件を絞り込んで（例：期間を短くするなど）再度お試しください。',
  dashboard_report_date_range_label: '集計対象期間',
  dashboard_report_date_range_max_days_error:
    '開始日～終了日は、{maxDays}日以内で設定してください。',
  dashboard_report_date_range_future_error: '終了日には、未来の日付を設定できません。',
  dashboard_report_date_range_order_error: '終了日は、開始日以降の日付を設定してください。',
  dashboard_report_basis_label: '集計基準',
  dashboard_report_basis_entry: '応募日',
  dashboard_report_basis_event: 'イベント日',

  // Shared SearchBox component
  searchbox_search_placeholder: 'キーワードで絞り込む',
  searchbox_no_results: '該当する項目がありません。',
  searchbox_select_placeholder: '選択してください。',

  // Navigation
  nav_template: 'テンプレート',

  // Template list page
  template_page_title: 'テンプレート',
  template_mail_tab: 'メール（{mailType}）',
  template_mail_company: '社内通知',
  template_mail_applicant: '応募者通知',
  template_tab_sms: 'SMS',
  template_create_button: '新規登録',

  // Template empty state
  template_no_items: '登録されたテンプレートはありません。',

  // Template form dialog — shared
  template_form_name_label: 'テンプレート名',
  template_form_tags_label: 'タグ',
  template_tag_1: '有効応募',
  template_tag_2: 'フォーム送付',
  template_tag_3: '面談設定送付',
  template_form_name_placeholder: '例: 応募受付完了メール',
  template_form_subject_label: '件名',
  template_form_subject_placeholder: '例: 【SAISOKU】ご応募ありがとうございます',
  template_form_body_label: '本文',
  template_form_body_placeholder_sms: '例: {{applicant.name}}様、ご応募ありがとうございます。',
  template_form_variable_insert_button: '変数を挿入',
  template_form_save_button: '保存',
  template_form_name_required_error: 'テンプレート名を入力してください。',
  template_form_name_max_error: 'テンプレート名は64文字以内で入力してください。',
  template_form_subject_required_error: '件名を入力してください。',
  template_form_subject_max_error: '件名は128文字以内で入力してください。',
  template_form_body_required_error: '本文を入力してください。',

  // Template duplicate error
  template_duplicate_name_error:
    'テンプレート名が既に使用されています。別のテンプレート名を入力してください。',

  // Template clone name suffix
  template_clone_name_suffix: 'のコピー',

  // Template form page — browser tab titles
  template_mail_create_title: '新規テンプレート作成（メール）',
  template_mail_update_title: 'テンプレートを編集（メール）',
  template_sms_create_title: '新規テンプレート作成（SMS）',
  template_sms_update_title: 'テンプレートを編集（SMS）',

  // Template form page — heading (mail templates show which mailTemplateType they belong to)
  template_mail_create_heading: '新規メールテンプレート作成（{mailTypeLabel}）',
  template_mail_update_heading: 'メールテンプレート編集（{mailTypeLabel}）',

  // Template form page — back button and save success
  template_back_to_list_button: '一覧に戻る',
  template_save_success: 'テンプレートを保存しました。',

  // Tiptapエディタツールバー
  template_form_editor_bold: '太字',
  template_form_editor_italic: '斜体',
  template_form_editor_underline: '下線',
  template_form_editor_h1: '見出し 1',
  template_form_editor_h2: '見出し 2',
  template_form_editor_h3: '見出し 3',
  template_form_editor_bullet_list: '箇条書き',
  template_form_editor_ordered_list: '番号付きリスト',
  template_form_editor_add_link: 'リンクを追加',
  template_form_editor_remove_link: 'リンクを削除',
  template_form_editor_clear_formatting: 'フォーマットをクリア',
  template_form_editor_enter_url: 'URLを入力してください',
  template_form_editor_link_dialog_title: 'リンクを追加',
  template_form_editor_link_dialog_label: 'URL',
  template_form_editor_link_dialog_placeholder: 'https://example.com',
  template_form_editor_link_dialog_confirm: '追加',
  template_form_editor_link_dialog_invalid_url:
    'http://、https://、mailto:、または相対パスで始まる有効なURLを入力してください。',

  // Template delete dialog
  template_delete_confirm_message: 'テンプレートを削除します。よろしいですか？',
  template_delete_confirm_button: '削除する',
  template_delete_error: 'テンプレートの削除に失敗しました。時間をおいて再度お試しください。',
  template_delete_in_use_title: '削除できません',
  template_delete_in_use_message:
    'このテンプレートは【{names}】（振り分けルール）に使用中のため、削除できません。\n【{names}】（振り分けルール）からこのテンプレートの設定を解除してから削除してください。',

  // Template list item
  template_item_id_label: 'ID:',
  template_item_created_at_label: '作成日:',
  template_item_edit_button: '編集',
  template_item_clone_button: '複製',
  template_item_delete_button: '削除',

  // SMS body character count
  template_sms_body_char_count: '{count} / 160 文字',

  // Variable placeholder labels
  template_var_form_url: 'フォームURL',
  template_var_form_url_file: 'ファイルアップロードURL',
  template_var_zloss_url: '面談URL',
  template_var_applicant_name: '応募者名',
  template_var_applicant_job_number: '求人番号（お仕事No.）',
  template_var_applicant_job_title: '求人タイトル',
  template_var_resume_id: 'レジュメID',
  template_var_resume_url: 'レジュメへのURL',
  template_var_system_account_name: 'エントリー経路（詳細）',
} as const;

export default ja;
